import { render, staticRenderFns } from "./TrainingOffline.vue?vue&type=template&id=521857d2&scoped=true"
import script from "./TrainingOffline.vue?vue&type=script&lang=js"
export * from "./TrainingOffline.vue?vue&type=script&lang=js"
import style0 from "./TrainingOffline.vue?vue&type=style&index=0&id=521857d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "521857d2",
  null
  
)

export default component.exports